import { useEffect, useCallback } from "react";
import {
  Route,
  Redirect,
  BrowserRouter as Router,
  Switch,
} from "react-router-dom";
import axios from "axios";

import { useDispatch } from "react-redux";
import * as authActions from "./store/auth";

import PrivateRoute from "./components/PrivateRoute";
import ChannelsPage from "./containers/ChannelsPage";
import LoginPage from "./containers/LoginPage";

import setAuthToken from "./utils/setAuthToken";
import RestrictedRoute from "components/RestricedRoute";
import PresencesPage from "containers/PresencesPage";

axios.defaults.baseURL = process.env.REACT_APP_SERVER_URL;

if (localStorage.authToken) {
  setAuthToken(localStorage.authToken);
}

const App = () => {
  const dispatch = useDispatch();
  const onRestoreToken = useCallback(
    () => dispatch(authActions.restoreToken()),
    [dispatch]
  );

  useEffect(() => {
    onRestoreToken();
  }, [onRestoreToken]);

  return (
    <Router>
      <Switch>
        <PrivateRoute exact path="/" component={ChannelsPage} />
        <Route path="/login" component={LoginPage} />
        <RestrictedRoute path="/presences" component={PresencesPage} />
        <Redirect to="/login" />
      </Switch>
    </Router>
  );
};

export default App;
